import { styled, TextField, TextFieldProps } from "@mui/material";
import colors from "../../theme/themeConstants";

const CustomInput = (props: TextFieldProps) => {
  return (
    <Container>
      {props.label && <label>{props.label}</label>}
      <TextField
        sx={{
          width: "100%",
          background: "transparent",
          ".Mui-focused, & div": {
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.23)!important",
              borderWidth: "1px"
            }
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            border: "1px solid rgba(216, 223, 236, 0.3)",
            padding: "1rem",
            fontSize: "14px"
          },
          "& .MuiFormHelperText-root.Mui-error": {
            margin: 0,
            marginTop: "5px",
          }
        }}
        {...props}
        label={null}
      />
    </Container>
  );
};

export default CustomInput;

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  "& label": {
    fontSize: "12px",
    color: colors.white,
    opacity: 0.8
  },
  "& input": {
    color: colors.white,
    padding: 0,
  },
  "& textarea": {
    color: colors.white
  },
  "& span": {
    fontWeight: 500,
    fontSize: "10px",
    opacity: 0.5
  }
});
